import { Field, From, Schema } from '@bonusly/schema';

import { ApprovalLevelSerializer } from './approval-level';
import { Condition, GroupType, NullableConditionsSerializer } from './groups';
import { User } from './users';

export enum AwardVisibility {
	Public = 'publicly_visible',
	Private = 'privately_visible',
	Team = 'immediate_team',
}

export enum AwardState {
	Active = 'active',
	Inactive = 'inactive',
}

export enum BudgetPeriod {
	Week = 'week',
	Month = 'month',
	Quarter = 'quarter',
	Year = 'year',
	Lifetime = 'lifetime',
}

@Schema()
export class Award {
	@Field()
	@From('id')
	public id = '';

	@Field()
	@From('amount')
	public amount = 0;

	@Field()
	@From('amountEditable')
	public amountEditable = false;

	@Field()
	@From('budgetUsed')
	public budgetUsed: number | null = null;

	@Field()
	@From('conditionsOperator')
	public conditionsOperator: GroupType | null = null;

	@Field(NullableConditionsSerializer)
	@From('conditions')
	public conditions: Condition[] | null = null;

	@Field()
	@From('giverId')
	public giverId = '';

	@Field()
	@From('iconUrl')
	public iconUrl = '';

	@Field()
	@From('message')
	public message = '';

	@Field()
	@From('name')
	public name = '';

	@Field()
	@From('state')
	public state = AwardState.Active;

	@Field()
	@From('periodType')
	public periodType: BudgetPeriod | null = null;

	@Field()
	@From('visibility')
	public visibility = AwardVisibility.Public;

	@Field()
	@From('budgetPerPeriod')
	public budgetPerPeriod = 0;

	@Field()
	@From('messageEditable')
	public messageEditable = false;

	@Field()
	@From('pendingApprovals')
	public pendingApprovals = 0;
}

@Schema()
export class AwardDetail {
	@Field()
	@From('id')
	public id = '';

	@Field()
	@From('amount')
	public amount = 0;

	@Field()
	@From('amountEditable')
	public amountEditable = false;

	@Field()
	@From('budgetUsed')
	public budgetUsed: number | null = null;

	@Field()
	@From('conditionsOperator')
	public conditionsOperator: GroupType | null = null;

	@Field(NullableConditionsSerializer)
	@From('conditions')
	public conditions: Condition[] | null = null;

	@Field()
	@From('giverId')
	public giverId = '';

	@Field()
	@From('iconUrl')
	public iconUrl = '';

	@Field()
	@From('name')
	public name = '';

	@Field()
	@From('description')
	public description = '';

	@Field()
	@From('state')
	public state = AwardState.Active;

	@Field()
	@From('periodType')
	public periodType: BudgetPeriod | null = null;

	@Field()
	@From('visibility')
	public visibility = AwardVisibility.Public;

	@Field()
	@From('visibilityEditable')
	public visibilityEditable = true;

	@Field()
	@From('budgetPerPeriod')
	public budgetPerPeriod = 0;

	@Field()
	@From('title')
	public title = '';

	@Field()
	@From('message')
	public message = '';

	@Field()
	@From('messageEditable')
	public messageEditable = false;

	@Field()
	@From('pendingApprovals')
	public pendingApprovals = 0;

	@Field(ApprovalLevelSerializer)
	@From('approvalLevels')
	public approvalLevels: User[][] = [];

	get isActive() {
		return this.state === AwardState.Active;
	}
}
